import React from 'react';
import { useLockContentControl } from 'features/layout/grid-panel/controls/GridPanelLockControl/useLockContentControl';
import { GridPanelControl } from 'features/layout/grid-panel/GridPanelControl';
import { useTranslation } from 'react-i18next';

export const GridPanelLockIndicator = () => {
  const { t } = useTranslation('room');

  const { isCurrentContentLocked, canLockContent } = useLockContentControl();

  if (!isCurrentContentLocked || canLockContent) {
    return null;
  }

  return (
    <GridPanelControl
      tooltip={t('grid.content_locked_tooltip')}
      aria-label={t('grid.content_locked_tooltip')}
      icon="lock"
      sx={{
        cursor: 'default',
      }}
    />
  );
};
